import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  subtitle: {
    color: theme.palette.text.primary, // for consistency with other setting page subtitles
  },
  subtitle2: {
    color: theme.palette.text.primary,
    marginBottom: 20,
  },
  heading: {
    marginBottom: 5,
  },
  optionContainer: {
    marginBottom: theme.spacing(2.5),
  },

  label: {
    marginRight: theme.spacing(1.25),
    color: theme.palette.text.primary,
  },
  microsoftDisclaimer: {
    display: "flex",
    flexDirection: "column",
  },
  disclaimerHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1),
  },
  disclaimerTitle: {
    color: theme.palette.black,
    fontWeight: 800,
  },
  disclaimerIcon: {
    color: theme.palette.yellow.dark,
  },
  disclaimerText: {
    textAlign: "left",
    marginBottom: theme.spacing(1),
  },
  disclaimerActions: {
    margin: "0 !important",
    paddingBottom: `${theme.spacing(2.5)} !important`,
  },
  disclaimerActionButtons: {
    width: "100%",
  },
  link: {
    textAlign: "left",
    textDecoration: "underline",
    color: theme.palette.blue.main,
  },
}));
